import { convertUTCtoUserLocalTimeZone } from '../../../../utils/utils';
import * as moment from 'moment-timezone';

const getDateBasedOnTab = (createdDate = '', updatedDate = '', closed) => {
  switch (closed) {
    case false:
      return createdDate;
    case true:
      return updatedDate;
  }
};

const convertMawb = response => {
  return response.map(item => ({
    ...item,
    MAWB: item?.mawb,
    shipperNickName: item?.shipperAddressNickname,
    destinationCountry: item?.destination_country,
    destination_service_code: item?.destination_service_code,
    createdDateTime: convertUTCtoUserLocalTimeZone(
      getDateBasedOnTab(item?.create_datetime, item?.lastupdated_datetime, item?.closed),
      item?.timezone,
      moment.tz.guess()
    ),
    label: item?.label ? item?.label : '',
    noOfPallets: item.palletIDList.length,
    totalWeight: item?.totalWeight,
    motherStatus: item?.closed ? 'Closed' : 'Open',
    commercial_invoice_found:
      item.commercial_invoice_ID && item.commercial_invoice_ID !== null ? true : false,
  }));
};
export { convertMawb };
